highchartsAdmin = window.highchartsAdmin || {};

highchartsAdmin = {
	init: function () {
		var $body = $('body');
		if ($body.hasClass('admin')
			&& ($body.hasClass('boxman') || $body.hasClass('sitemap'))
			&& $('#boxman_menu').length > 0) {
			highchartsAdmin.boxman.init();
		}
	},

	form: function (options) {
		$('#modal-btn').on('click', function (e) {
			e.preventDefault();
		});

		highed.ready(function () {
			if (options) {
				highed.option('stickyChartProperties', options);
			}

			highed.ModalEditor('modal-btn', {
				allowDone: true,
				features: 'welcome import templates customize done',
				importer: {
					options: 'plugins csv json samples'
				}
			}, function (chart) {
				//on editor close
				var html = chart.export.html(false);
				highed.dom.get('html').value = html;
				$('#preview').html(html);

				var json = chart.toProject();
				highed.dom.get('project').value = JSON.stringify(json);

			}, function (editor) {
				//on editor load
				var project = highed.dom.get('project').value,
					project = (project) ? JSON.parse(project) : {};
				if (project.options) {
					editor.chart.loadProject(project);
					$('.highed-imp-pastearea').text(project.options.data.csv)

					var firstRow = (project.options.data.firstRowAsNames === true);
					$('input[type="checkbox"].highed-imp-input').attr('checked', firstRow);
				}
			});
		});
	},

	boxman: {
		init: function () {
			$("#dialog").on("dialogopen", function (event, ui) {
				highchartsAdmin.boxman.waitUntil(function () {
					return $('#title', '.boxmanBoxForm').length > 0;
				}, function () {
					highchartsAdmin.multiform();
				}, function () {
				});
			});
		},

		waitUntil: function (isready, success, error, count, interval) {
			if (count === undefined) {
				count = 100;
			}
			if (interval === undefined) {
				interval = 20;
			}
			if (isready()) {
				success();
				return;
			}
			// The call back isn't ready. We need to wait for it
			setTimeout(function () {
				if (!count) {
					// We have run out of retries
					if (error !== undefined) {
						error();
					}
				} else {
					// Try again
					highchartsAdmin.boxman.waitUntil(isready, success, error, count - 1, interval);
				}
			}, interval);
		}
	},

	multiform: function () {
		$.localise('ui-multiselect', {language: moya.lang, path: '/_moya/js/jquery/multiselect/js/locale/'});
		$('#charts').multiselect({
			sortable: true,
			searchable: false,
		});
	}
};

highchartsAdmin.init();
